import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

import { FormBaseComponent } from '../shared/formbase/formbase.component';

import { GlobalService } from '../global.service';
import { AjaxService } from '../ajax.service';
import { UploadService } from '../upload.service';

@Component({
    selector: 'app-formulier',
    templateUrl: './form.page.html',
    styleUrls: ['./form.page.scss'],
    standalone: false
})
export class FormPage implements OnInit {
    @ViewChild(FormBaseComponent) public formBase!: FormBaseComponent;

    formHdr = '';
    formID: number = null;
    form: any = []; // ingevulde antwoorden
    formulier = [];
    ondertekDD = new Date();
    viewerOpen = false;
    idx = 1;
    initDone = false;

    ordnr = '';

    constructor(
        public router: Router,
        private route: ActivatedRoute,
        public global: GlobalService,
        private ajax: AjaxService,
        private snackBar: MatSnackBar,
    ) {
    }

    ngOnInit() {
        if (!this.global.isLoggedIn) {
            this.router.navigateByUrl('login');
        }
    }

    ionViewWillEnter() {
        this.route.params.subscribe(params => {
            this.formHdr = params.formnr;
            if (params.formnr.substr(0, 3) === 'NEW') {
                // nieuw aan te maken formulier
                this.ordnr = params.ordnr;
            } else {
                // bestaand formulier
                this.ordnr = '';
            }
            this.initDone = true;
        });
    }

    public confirmButtons = [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'OK',
          role: 'confirm',
        },
    ];

    doVrijgave(ev) {
        if (ev.detail.role === 'confirm') {
            this.formBase.save();
        }
    }
}
